import { FC } from 'react'

interface ShowcaseStatItemProps {
	label: string
	value: string | number
	suffix?: string
	className?: string
}

const ShowcaseStatItem: FC<ShowcaseStatItemProps> = ({ label, value, suffix = '', className = '' }) => (
	<div className={`flex justify-between items-center ${className}`}>
		<span className="text-lg opacity-90">{label}:</span>
		<span className="text-xl font-bold">
			{value}
			{suffix}
		</span>
	</div>
)

export default ShowcaseStatItem
